<template>
  <v-flex>
    <v-container class="pt-5 pb-4">
      <v-layout row wrap>
        <v-flex xs6>
          <v-btn flat color="primary" class="mx-0" href="/AuthorDashboard/CourseListing">
            <v-icon dark>
              keyboard_arrow_left
            </v-icon>
            Back to Course Listing
          </v-btn>
        </v-flex>
        <v-layout xs6 justify-end>
          <v-btn v-if="isAdmin" icon flat class="mr-3 red--text" @click="deleteCourse(courseId)">
            <v-icon>fas fa-trash</v-icon>
          </v-btn>
          <v-btn color="info" :href="'/curriculum/'+courseId" target="_blank">
            Preview Course
          </v-btn>
        </v-layout>
      </v-layout>
    </v-container>
    <v-tabs v-model="selectedTab" fixed-tabs centered color="transparent">
      <v-tabs-slider />
      <v-tab v-if="!isPeerReviewer || isAdmin" href="#Metadata" class="primary--text" :ripple="false">
        Metadata
      </v-tab>
      <v-tab v-if="!isPeerReviewer || isAdmin" href="#Files" class="primary--text" :ripple="false">
        Files
      </v-tab>
      <v-tab v-if="!isPeerReviewer || isAdmin" href="#Organization" class="primary--text" :ripple="false">
        Organization
      </v-tab>
      <v-tab href="#Workflow" class="primary--text" :ripple="false">
        Workflow
      </v-tab>
      <v-tab v-if="isAdmin" href="#ActivityLog" class="primary--text" :ripple="false">
        Course Activity
      </v-tab>
    </v-tabs>
    <v-divider class="ma-0" />

    <v-tabs-items v-model="selectedTab">
      <v-tab-item v-if="!isPeerReviewer || isAdmin" value="Metadata" :transition="false" :reverse-transition="false">
        <metadata-tab :is-admin="isAdmin" :is-peer-reviewer="isPeerReviewer" :course-id="courseId" :grade-levels="gradeLevels" :programs="programs" :resource-types="resourceTypes" :selected-tab="selectedTab" />
      </v-tab-item>
      <v-tab-item v-if="!isPeerReviewer || isAdmin" value="Files" :transition="false" :reverse-transition="false" lazy>
        <files-management-tab :is-admin="isAdmin" :is-peer-reviewer="isPeerReviewer" :course-id="courseId" :selected-tab="selectedTab" />
      </v-tab-item>
      <v-tab-item v-if="!isPeerReviewer || isAdmin" value="Organization" :transition="false" :reverse-transition="false" lazy>
        <organization-tab :is-admin="isAdmin" :is-peer-reviewer="isPeerReviewer" :course-id="courseId" :selected-tab="selectedTab" />
      </v-tab-item>
      <v-tab-item value="Workflow" :transition="false" :reverse-transition="false" lazy>
        <workflow-tab :is-admin="isAdmin" :is-peer-reviewer="isPeerReviewer" :course-id="courseId" :selected-tab="selectedTab" :is-author="isAuthor" />
      </v-tab-item>
      <v-tab-item v-if="isAdmin" value="ActivityLog" :transition="false" :reverse-transition="false" lazy>
        <activity-log-tab :course-id="courseId" :selected-tab="selectedTab" />
      </v-tab-item>
    </v-tabs-items>
  </v-flex>
</template>
<script>
  import axios from 'axios';
  import MetadataTab from './components/MetadataTab.vue';
  import FilesManagementTab from './components/FilesManagementTab.vue';
  import OrganizationTab from './components/OrganizationTab.vue';
  import ManageCourseBase from './components/ManageCourseBase.vue';
  import WorkflowTab from './components/WorkflowTab.vue';
  import ActivityLogTab from './components/ActivityLogTab.vue';

  export default {
    parent: true,
    components: {
      MetadataTab,
      FilesManagementTab,
      OrganizationTab,
      WorkflowTab,
      ActivityLogTab,
    },
    extends: ManageCourseBase,

    data: () => ({
      tabs: ['Metadata', 'Files', 'Organization', 'Workflow'],
      selectedTab: 'Metadata',
      // selectedTab: 'Workflow',
    }),

    watch: {
      selectedTab() {
        window.scrollTo(0, 0);
      },
    },

    mounted() {
      if (this.isPeerReviewer && !this.isAdmin) {
        this.selectedTab = 'Workflow';
      }
    },

    methods: {
      async deleteCourse(courseId) {
        const result = confirm('Are you sure you want to delete this course? It will be queued for deletion and removed from the system shortly. There will be no way to recover the course files.'); // eslint-disable-line
        if (result) {
          await axios.delete(`/api/courses/${courseId}`);
          window.location.replace('/AuthorDashboard/CourseListing');
        }
      },
    },
  };
</script>
<style>
.v-window__container
  {
    height: 100% !important;
  }
</style>